import useCarouselLayout from "../../hooks/useCarouselLayout";
import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight, FaTrophy, FaPause, FaPlay } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./StudentResults.css";

// Sample results only. Replace names, classes, fields, and percentages with verified records.
const studentResults = [
  { id: 1, name: "Ananya Das", className: "Class XII", field: "Science", percentage: 98.4 },
  { id: 2, name: "Rohan Sen", className: "Class X", field: "General Studies", percentage: 97.2 },
  { id: 3, name: "Ishita Roy", className: "Class XII", field: "Commerce", percentage: 96.8 },
  { id: 4, name: "Sayan Paul", className: "Class XI", field: "Science", percentage: 95.6 },
  { id: 5, name: "Diya Dey", className: "Class XII", field: "Humanities", percentage: 94.8 },
];

export default function StudentResults() {
  const sliderRef = useRef(null);
  const { containerRef, slidesToShow } = useCarouselLayout(3);
  const [isPlaying, setIsPlaying] = useState(true);
  const settings = {
    infinite: true, autoplay: isPlaying, autoplaySpeed: 3500, speed: 800,
    cssEase: "cubic-bezier(0.22, 1, 0.36, 1)", arrows: false, dots: false,
    slidesToShow, slidesToScroll: 1, pauseOnHover: true, pauseOnFocus: true,

  };

  return (
    <section className="home-results" aria-labelledby="home-results-title">
      <div className="home-results__container" ref={containerRef}>
        <div className="home-results__heading">
          <div>
            <span className="home-results__eyebrow">Celebrating progress</span>
            <h2 id="home-results-title">Student results</h2>
            <p>Explore achievements by class, field of study, and percentage.</p>
            <small>Sample results for demonstration.</small>
          </div>
          <div className="home-results__controls" aria-label="Student results slider controls">
            <button type="button" aria-label="Previous results" onClick={() => sliderRef.current?.slickPrev()}><FaChevronLeft aria-hidden="true" /></button>
            <button type="button" aria-label={isPlaying ? "Pause automatic results slider" : "Play automatic results slider"}
              onClick={() => {
                if (isPlaying) sliderRef.current?.slickPause();
                else sliderRef.current?.slickPlay();
                setIsPlaying(!isPlaying);
              }}>
              {isPlaying ? <FaPause aria-hidden="true" /> : <FaPlay aria-hidden="true" />}
            </button>
            <button type="button" aria-label="Next results" onClick={() => sliderRef.current?.slickNext()}><FaChevronRight aria-hidden="true" /></button>
          </div>
        </div>
        <Slider ref={sliderRef} {...settings}>
          {studentResults.map((student) => (
            <div key={student.id}>
              <article className="home-results__card">
                <div className="home-results__badge"><FaTrophy aria-hidden="true" /><span>Academic achievement</span></div>
                <div className="home-results__percentage">{student.percentage}<span>%</span></div>
                <h3>{student.name}</h3>
                <dl><div><dt>Class</dt><dd>{student.className}</dd></div><div><dt>Field</dt><dd>{student.field}</dd></div></dl>
                <div className="home-results__meter" aria-hidden="true"><span style={{ width: `${student.percentage}%` }} /></div>
              </article>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
